/**
 * Firebase Analytics (GA4) - production only, fail-silent.
 *
 * Dev servers and unsupported environments (no cookies, some embeds)
 * never initialize, and a failed init must never affect the editor -
 * track() is always safe to call. page_view/session events are automatic
 * once initialized; we add the cloud-action events on top.
 */
import { getFirebaseApp } from './firebaseApp.js';

let analytics = null;      // Analytics instance once ready
let logEventFn = null;     // firebase/analytics logEvent

/** Initialize analytics (no-op outside production builds). */
export async function initAnalytics() {
    if (!import.meta.env.PROD) return;
    try {
        const [app, mod] = await Promise.all([
            getFirebaseApp(),
            import('firebase/analytics')
        ]);
        if (!(await mod.isSupported())) return;
        analytics = mod.getAnalytics(app);
        logEventFn = mod.logEvent;
    } catch (e) {
        console.warn('analytics init skipped:', e?.message);
    }
}

/**
 * Log an event (silently dropped until/unless analytics is live).
 * Use GA4 standard names where they exist (login, sign_up, share).
 * @param {string} name
 * @param {Object} [params]
 */
export function track(name, params = {}) {
    if (!analytics || !logEventFn) return;
    try {
        logEventFn(analytics, name, params);
    } catch { /* never let telemetry break the app */ }
}
